"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  GenderMale: ['gender-male', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M13.564 10.446L23.239 0.75', 'M2.958,10.446a7.5,7.5,0,1,1,0,10.607A7.5,7.5,0,0,1,2.958,10.446Z', 'M16.489 0.75L23.239 0.75 23.239 7.5']],
  GenderGay: ['gender-gay', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M12,6.569a6,6,0,1,1-7.165-.256', 'M8.25 17.25L8.25 23.25', 'M11.25 20.25L8.25 23.25 5.25 20.25', 'M9.634,13.824A6.05,6.05,0,0,1,7.606,8.107,6.057,6.057,0,0,1,17.743,4.992a6,6,0,0,1,.49,7.932', 'M17.743 4.992L21.75 0.75', 'M18 0.75L21.75 0.75 21.75 4.5']],
  GenderHetero: ['gender-hetero', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M12,6.569a6,6,0,1,1-7.165-.256', 'M8.25 17.25L8.25 23.25', 'M9.634,13.824a6,6,0,1,1,8.6-.9', 'M17.743 4.992L21.75 0.75', 'M18 0.75L21.75 0.75 21.75 4.5', 'M5.25 20.25L11.25 20.25']],
  GenderBisexual: ['gender-bisexual', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M12.75,23.25H15l.75-4.5h3L16.5,12c-.75-2.25-1.679-3.75-3.75-3.75', 'M12.75.75a3,3,0,0,1,0,6', 'M9.75,6.75a3,3,0,0,1,0-6', 'M9.75,8.25a4.5,4.5,0,0,0-4.5,4.5v3h1.5l.75,7.5H9.75', 'M3.75.75H2.25a1.5,1.5,0,0,0-1.5,1.5v19.5a1.5,1.5,0,0,0,1.5,1.5h1.5', 'M20.25.75h1.5a1.5,1.5,0,0,1,1.5,1.5v19.5a1.5,1.5,0,0,1-1.5,1.5h-1.5']],
  GenderLesbian: ['gender-lesbian', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M12,6.569a6,6,0,1,1-7.165-.256', 'M8.25 17.25L8.25 23.25', 'M9.634,13.824a6.058,6.058,0,0,1-.448-8.759l.071-.073a6,6,0,0,1,8.976,7.932', 'M17.743 4.992L21.75 0.75', 'M5.25 20.25L11.25 20.25', 'M21.75 4.5L18 0.75']],
  GenderFemale: ['gender-female', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M12 15.75L12 23.25', 'M9 20.25L15 20.25', 'M4.500 8.250 A7.500 7.500 0 1 0 19.500 8.250 A7.500 7.500 0 1 0 4.500 8.250 Z']],
  GenderTransgender: ['gender-transgender', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M12 17.25L12 23.25', 'M18.75 0.75L22.5 0.75 22.5 4.5', 'M5.25 0.75L1.5 0.75 1.5 4.5', 'M9 20.25L15 20.25', 'M6.000 11.250 A6.000 6.000 0 1 0 18.000 11.250 A6.000 6.000 0 1 0 6.000 11.250 Z', 'M6.75 3L3.75 6', 'M1.5 0.75L7.757 7.007', 'M22.5 0.75L16.242 7.007']]
};
exports["default"] = _default;